import { useMemo } from "react";
import { useBrandGroup } from "entities/hooks/useBrandGroup";
import {
  BREADCRUMB_PERMISSIONS,
  hasBreadcrumbPermission,
} from "helpers/chrome/locations";

export const useStoresWithManageableUserPermission = () => {
  const activeBrand = useBrandGroup();
  return useMemo(() => {
    const hasManageUserPermission = hasBreadcrumbPermission(
      BREADCRUMB_PERMISSIONS.USERS
    );
    return activeBrand?.stores?.filter((store) => {
      return hasManageUserPermission(store);
    });
  }, [activeBrand?.stores]);
};
